import React from 'react';
import { trustPoints } from '../data/mock';
import { CheckCircle2 } from 'lucide-react';

const TrustSafety = () => {
  return (
    <section id="trust" className="section-container">
      <div className="section-header">
        <h2 className="section-title">Trust & Safety</h2>
        <p className="section-subtitle">Your control. Your confidence. Your timeline.</p>
      </div>

      <div className="trust-content">
        <div className="trust-points">
          {trustPoints.map((point, index) => (
            <div key={index} className="trust-point">
              <CheckCircle2 className="trust-icon" />
              <p className="trust-text">{point}</p>
            </div>
          ))}
        </div>

        <div className="trust-message">
          <p className="trust-emphasis">
            We never move your money without clear consent.
          </p>
          <p className="trust-detail">
            Draft, review, and execute — or test in paper mode if you prefer.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustSafety;
